import React, { useEffect } from 'react'
import '../../assets/css/salesforce.css'

const Salesforce = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    SALESFORCE SOLUTIONS
                                </h1>
                                <p className="breadcrumb-subtitle text-white">
                                    Salesforce Professional Services include consulting, implementation, support, and related services designed to<br /> help businesses fully leverage and maximize the value of Salesforce.

                                </p>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Our Salesforce </span> Services
                                </h2>
                                <p className="ai-driven-description">
                                    CLOUD MIND X provides a full suite of Salesforce professional services designed to support and enhance your CRM strategy through tailored, scalable, and future-ready software solutions. From Salesforce consulting and implementation to customization, integration, and ongoing support, we help businesses streamline operations, improve customer engagement, and drive sustainable growth with confidence.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src={require('../../assets/images/Salesforce.jpg')}
                                    alt="AI-Driven Business Evolution"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Salesforce Services Section */}
            <section className="salesforce-services-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-services-title">
                                Our <span className="text-gradient">Salesforce Services</span>
                            </h2>
                            <p className="salesforce-services-subtitle">
                                Comprehensive Salesforce solutions tailored to transform your business operations
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Service Card 1 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce Consulting</h3>
                                <p className="sf-service-description">
                                    Expert guidance to align Salesforce with your business goals. We analyze your processes, recommend best practices, and create a strategic roadmap for successful CRM implementation and optimization.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 2 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 6V18" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M3 12H21" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce Implementation</h3>
                                <p className="sf-service-description">
                                    Seamless deployment of Salesforce tailored to your unique requirements. From setup and configuration to data migration and user training, we ensure a smooth transition and rapid adoption.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 3 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce Customization</h3>
                                <p className="sf-service-description">
                                    Tailor Salesforce to fit your business perfectly. We customize objects, fields, workflows, and automation rules to match your specific processes and enhance productivity across your organization.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 4 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="4" y="4" width="16" height="16" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M8 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M16 2V6" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4 10H20" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce App Development</h3>
                                <p className="sf-service-description">
                                    Build custom applications on the Salesforce platform. Our developers create powerful, scalable apps using Lightning Components, Apex, and Visualforce to extend Salesforce functionality.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 5 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12H3M12 21C7.02944 21 3 16.9706 3 12M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M3 12C3 7.02944 7.02944 3 12 3" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce Migration</h3>
                                <p className="sf-service-description">
                                    Migrate your data securely from legacy systems to Salesforce. We ensure data integrity, minimize downtime, and provide comprehensive testing for a risk-free transition to your new CRM.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 6 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="3" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 1V3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M12 21V23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 4.22L5.64 5.64" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 18.36L19.78 19.78" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M1 12H3" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M21 12H23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M4.22 19.78L5.64 18.36" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18.36 5.64L19.78 4.22" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce Integration</h3>
                                <p className="sf-service-description">
                                    Connect Salesforce with your existing business systems. We integrate with ERP, marketing automation, accounting software, and third-party applications for seamless data flow and unified operations.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 7 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 22V12" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M7 9.5L2 12V17L12 22L22 17V12L17 9.5" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Salesforce Upgrade</h3>
                                <p className="sf-service-description">
                                    Stay current with the latest Salesforce features and capabilities. We handle version upgrades, feature adoption, and system optimization to ensure you're leveraging the full power of the platform.
                                </p>
                            </div>
                        </div>

                        {/* Service Card 8 */}
                        <div className="col-lg-4 col-md-6 mt-4">
                            <div className="sf-service-card">
                                <div className="sf-service-icon">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M12 6V12L16 14" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-service-title">Support & Maintenance</h3>
                                <p className="sf-service-description">
                                    Ongoing support to keep your Salesforce running smoothly. We provide 24/7 technical assistance, regular health checks, performance optimization, and continuous improvements to maximize ROI.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Salesforce Clouds Expertise Section */}
            <section className="salesforce-clouds-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center mb-5">
                            <h2 className="salesforce-clouds-title">
                                Our Expertise in <span className="text-gradient">Salesforce Clouds</span>
                            </h2>
                            <p className="salesforce-clouds-subtitle">
                                Provide a personalized Salesforce experience that seamlessly aligns with your organization's goals and objectives.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {/* Sales Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">
                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00D4FF" />
                                        <path d="M18 24L22 28L30 20" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Sales Cloud</h3>
                            </div>
                        </div>

                        {/* Service Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FF6B9D" />
                                        <path d="M24 14C28.4183 14 32 17.5817 32 22C32 26.4183 28.4183 30 24 30C19.5817 30 16 26.4183 16 22C16 17.5817 19.5817 14 24 14Z" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 30V34" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Service Cloud</h3>
                            </div>
                        </div>

                        {/* Marketing Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A1E0" />
                                        <path d="M14 24L20 18L26 24L34 16" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M28 16H34V22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Marketing Cloud</h3>
                            </div>
                        </div>

                        {/* Community Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#A78DFF" />
                                        <circle cx="24" cy="18" r="4" stroke="white" strokeWidth="2.5" />
                                        <circle cx="16" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                        <circle cx="32" cy="28" r="3" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Community Cloud</h3>
                            </div>
                        </div>

                        {/* Financial Services Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#8B5CF6" />
                                        <path d="M16 20H32M16 20V30H32V20M16 20L24 14L32 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M20 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M24 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <path d="M28 26V30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Financial Services Cloud</h3>
                            </div>
                        </div>

                        {/* NonProfit Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#FFA726" />
                                        <path d="M24 14L19 19V32H29V19L24 14Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19 22H29" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">NonProfit Cloud</h3>
                            </div>
                        </div>

                        {/* Salesforce CPQ */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A8E1" />
                                        <circle cx="24" cy="24" r="8" stroke="white" strokeWidth="2.5" />
                                        <path d="M24 16V14M24 34V32M16 24H14M34 24H32" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Salesforce CPQ</h3>
                            </div>
                        </div>

                        {/* Salesforce Commerce Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#10B981" />
                                        <path d="M16 18L20 14L24 18L28 14L32 18V30C32 31.1046 31.1046 32 30 32H18C16.8954 32 16 31.1046 16 30V18Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Salesforce Commerce Cloud</h3>
                            </div>
                        </div>

                        {/* Salesforce Mulesoft */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A3E0" />
                                        <path d="M14 24H34M24 14V34" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <circle cx="24" cy="24" r="4" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Salesforce Mulesoft</h3>
                            </div>
                        </div>

                        {/* Salesforce Lightning */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#00A1E0" />
                                        <path d="M28 14L18 26H24L20 34L30 22H24L28 14Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Salesforce Lightning</h3>
                            </div>
                        </div>

                        {/* Salesforce Einstein Analytics */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#6366F1" />
                                        <path d="M14 28L18 24L22 28L28 20L34 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="18" cy="24" r="1.5" fill="white" />
                                        <circle cx="22" cy="28" r="1.5" fill="white" />
                                        <circle cx="28" cy="20" r="1.5" fill="white" />
                                        <circle cx="34" cy="24" r="1.5" fill="white" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Salesforce Einstein Analytics</h3>
                            </div>
                        </div>

                        {/* Health Cloud */}
                        <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-4">

                            <div className="sf-cloud-box">
                                <div className="sf-cloud-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" fill="#A855F7" />
                                        <path d="M24 30V18M18 24H30" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
                                        <circle cx="24" cy="24" r="10" stroke="white" strokeWidth="2.5" />
                                    </svg>
                                </div>
                                <h3 className="sf-cloud-name">Health Cloud</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="salesforce-contact-section">
                <div className="salesforce-contact-overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="salesforce-contact-content">
                                <h2 className="salesforce-contact-title">Get in touch</h2>
                                <p className="salesforce-contact-description">
                                    Ready to turn your Salesforce solution into an efficient facilitator of long-term relationships with customers? Contact our consultants to decide what Salesforce services you need.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center text-lg-end">
                            <button className="salesforce-contact-btn">
                                Contact us
                            </button>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default Salesforce